import { Button, Modal } from "antd";
import { useCallback } from "react";
import { useIntl } from "react-intl";
import type { PromotionRelegationRuleTableRow } from "~Features/EditSeason/components/PromotionRelegationRules/types/promotionRelegationRuleTableRow.ts";

type Props = {
  onDelete: (row: PromotionRelegationRuleTableRow) => void;
  record: PromotionRelegationRuleTableRow;
};

export const DeletePromotionRelegationRuleAction = ({ onDelete, record }: Props) => {
  const { formatMessage } = useIntl();
  const [modal, contextHolder] = Modal.useModal();

  const handleClick = useCallback(() => {
    modal.confirm({
      title: formatMessage({ id: "promotion.relegation.rules.delete" }),
      content: formatMessage({ id: "promotion.relegation.rules.confirm" }),
      okText: formatMessage({ id: "delete" }),
      okButtonProps: { loading: false },
      onOk: () => {
        onDelete(record);
      },
    });
  }, [onDelete, formatMessage, modal, record]);

  return (
    <>
      <Button onClick={handleClick} type="text" size="small" icon={<i className="fas fa-trash-can mr-2" />} />
      {contextHolder}
    </>
  );
};
